import { render, staticRenderFns } from "./dossier-detail-component-lot-tab.vue?vue&type=template&id=f71c7cec&scoped=true"
import script from "./dossier-detail-component-lot-tab.vue?vue&type=script&lang=ts"
export * from "./dossier-detail-component-lot-tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71c7cec",
  null
  
)

export default component.exports